import loadable from '@loadable/component';
import React from 'react';

export function lazyImport<
  T extends React.ComponentType<any>,
  I extends { [K2 in K]: T },
  K extends keyof I,
>(factory: () => Promise<I>, name: K): I {
  return Object.create({
    [name]: loadable(() => factory(), { resolveComponent: (components) => components[name] }),
  });
}

// Usage
// const { Home } = lazyImport(() => import("./Home"), "Home");
